import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SessionStore } from '@/app/core/state/session-store';

type PermissionRouteData = {
  permission?: string | string[];
};

export const permissionGuard: CanActivateFn = async (route) => {
  const session = inject(SessionStore);
  const data = route.data as PermissionRouteData;
  const permissions = Array.isArray(data.permission)
    ? data.permission
    : data.permission
      ? [data.permission]
      : [];

  return session.isGrantedAny(permissions);
};
